// TopRankPulse translations - Base languages (EN, SK, CS, DE, PL, HU)
export const baseTranslations = {
  en: {
    hero_title: "See If AI Search Engines",
    hero_title_highlight: "Cite Your Website",
    hero_subtitle: "The only tool that tracks your visibility in ChatGPT, Perplexity & Gemini. Get a complete SEO, GEO & AI audit in seconds.",
    analyze_btn: "Analyze Now",
    placeholder: "Enter your website URL...",
    discount_text: "75% OFF - Limited Time",
    discount_ends: "Offer ends in",
    analyzing: "Analyzing your website...",
    scanning_seo: "Scanning SEO metrics",
    checking_ai: "Checking AI visibility",
    analyzing_geo: "Analyzing GEO factors",
    generating: "Generating AI solutions",
    results_title: "Your Analysis Results",
    ai_visibility: "AI Visibility Score",
    seo_audit: "SEO Audit",
    geo_analysis: "GEO Analysis",
    performance: "Performance",
    competitors: "Competitors",
    ai_solutions: "AI-Powered Solutions",
    pricing_title: "Choose Your Plan",
    pricing_subtitle: "Start free, upgrade when you need more power",
    get_started: "Get Started",
    features: "Features",
    per_month: "/month",
    original_price: "Original price",
    chatgpt_ready: "ChatGPT Ready",
    perplexity_ready: "Perplexity Ready",
    gemini_ready: "Gemini Ready",
    voice_search: "Voice Search Score",
    zero_click: "Zero-Click Potential",
    detected_region: "Detected Region",
    local_keywords: "Local Keywords",
    local_schema: "Local Schema",
    load_time: "Load Time",
    mobile_friendly: "Mobile Friendly",
    core_web_vitals: "Core Web Vitals",
    impact: "Impact",
    effort: "Effort",
    priority: "Priority",
    actions: "Actions",
    trusted_by: "Trusted by 10,000+ businesses worldwide",
    your_location: "Your location",
    what_makes_different: "What Makes Us Different",
    features_competitors_dont_have: "Features that competitors don't have",
    ai_citation_tracking: "AI Citation Tracking",
    ai_citation_desc: "Track if ChatGPT, Perplexity, and Gemini cite your website in their responses. No other tool offers this.",
    voice_search_ready: "Voice Search Ready",
    voice_search_desc: "Optimize for voice assistants and conversational queries. Get a dedicated Voice Search Score.",
    zero_click_analytics: "Zero-Click Analytics",
    // A/B Test Report translations
    ab_test_report: "A/B Test Report",
    compare_results: "Compare Results",
    before: "Before",
    after: "After",
    change: "Change",
    days_between: "days between analyses",
    improvements: "Improvements",
    regressions: "Regressions",
    ai_insights: "AI Insights",
    seo_changes: "SEO Changes",
    geo_changes: "GEO Changes",
    performance_changes: "Performance Changes",
    view_history: "View History",
    compare_with_previous: "Compare with Previous",
    no_previous_analysis: "No previous analysis found",
    improvement_rate: "Improvement Rate",
    zero_click_desc: "Understand how often your site appears in search without getting clicked. Optimize for featured snippets.",
    // Email capture translations
    email_required: "Get Your Free Analysis",
    email_subtitle: "Enter your email to receive the full SEO/GEO audit report",
    email_placeholder: "your@email.com",
    email_submit: "Send My Report",
    email_privacy: "We respect your privacy. No spam, ever.",
    email_marketing_consent: "Send me TopRankPulse offers by email (max. 5 until the end of the year, one-click unsubscribe).",
    email_invalid: "Please enter a valid email address",
    // AI Chat translations
    chat_title: "AI Assistant",
    chat_subtitle: "Ask me anything about SEO & Marketing",
    chat_placeholder: "Type your question...",
    chat_send: "Send",
    chat_greeting: "Hello! I'm TopRankPulse AI. How can I help you with SEO, GEO, or marketing today?",
    chat_thinking: "Thinking...",
    // Keyword Research & Content Writer
    tools_title: "SEO Tools",
    keyword_research: "Keyword Research",
    keyword_placeholder: "Enter seed keyword...",
    keyword_search: "Research",
    keyword_results: "Keyword Results",
    search_volume: "Volume",
    difficulty: "Difficulty",
    trend: "Trend",
    intent: "Intent",
    related_topics: "Related Topics",
    questions_asked: "Questions People Ask",
    long_tail_keywords: "Long-tail Keywords",
    content_writer: "Content Writer",
    content_type: "Content Type",
    content_topic: "Topic",
    content_keywords: "Target Keywords",
    content_tone: "Tone",
    content_generate: "Generate Content",
    content_result: "Generated Content",
    seo_score: "SEO Score",
    copy_content: "Copy",
    suggestions: "Suggestions",
    // Templates
    templates_title: "Quick Templates",
    templates_subtitle: "Click to auto-fill the form",
    tpl_ecommerce: "E-commerce",
    tpl_saas: "SaaS",
    tpl_local: "Local Business",
    tpl_blog: "Blog / Media",
    tpl_social: "Social Media",
    // Admin Dashboard
    admin_title: "Admin Dashboard",
    admin_leads: "Leads",
    admin_chats: "Chat Logs",
    admin_discounts: "Discount Codes",
    admin_total: "Total",
    admin_hot_leads: "Hot Leads",
    admin_avg_score: "Avg Score",
    admin_new: "New",
    admin_reviewed: "Reviewed",
    admin_used: "Used",
    admin_unused: "Unused",
    admin_conversion: "Conversion Rate",
    admin_email: "Email",
    admin_url: "URL",
    admin_score: "Score",
    admin_grade: "Grade",
    admin_date: "Date",
    admin_status: "Status",
    admin_language: "Language",
    admin_question: "Question",
    admin_answer: "Answer",
    admin_code: "Code",
    admin_type: "Type",
    admin_discount: "Discount",
    admin_expires: "Expires",
    admin_back: "Back to Site",
    admin_export: "Export",
    admin_filter_all: "All",
    admin_no_data: "No data available yet",
    admin_mark_reviewed: "Mark Reviewed",
    // Landing page enhancements
    free_tools: "100% Free Tools",
    free_tools_desc: "No credit card required. Instant results.",
    analyses_done: "analyses completed",
    schedule_rescan: "Schedule Rescan",
    rescan_frequency: "Frequency",
    rescan_daily: "Daily",
    rescan_weekly: "Weekly",
    rescan_monthly: "Monthly",
    rescan_scheduled: "Rescan scheduled!",
    all_free_title: "Everything Included Free",
    all_free_items: "SEO Audit,AI Visibility Score,GEO Analysis,Keyword Research,Content Writer,AI Chat Assistant,A/B Test Reports,Competitor Analysis",
    // AI Models Section
    ai_models_title: "We Track Your Visibility Across",
    ai_models_subtitle: "Every Major AI Search Engine",
    ai_models_desc: "No registration. No code. Results in seconds.",
    ai_chatgpt: "ChatGPT",
    ai_perplexity: "Perplexity",
    ai_gemini: "Gemini",
    ai_copilot: "Copilot",
    ai_models_cta: "See if they cite your website",
    // Backlink Checker
    backlink_checker: "Backlink Checker",
    backlink_url_placeholder: "Enter URL to check backlinks...",
    backlink_check: "Check Backlinks",
    backlink_total: "Total Backlinks",
    backlink_dofollow: "Dofollow",
    backlink_nofollow: "Nofollow",
    backlink_da: "Avg Domain Authority",
    backlink_score: "Backlink Score",
    backlink_domains: "Referring Domains",
    backlink_top: "Top Backlinks",
    backlink_anchors: "Anchor Texts",
    backlink_source: "Source",
    backlink_anchor: "Anchor",
    backlink_type: "Type",
    backlink_page: "Page Type",
    // Before vs After
    comparison_title: "The Difference is Clear",
    comparison_without: "Without TopRankPulse",
    comparison_with: "With TopRankPulse",
    comparison_clicks: "clicks/month",
    comparison_not_visible: "Not visible to AI",
    comparison_recommended: "Recommended by AI",
    // Site Speed
    site_speed: "Site Speed",
    speed_url_placeholder: "Enter URL to analyze speed...",
    speed_check: "Analyze Speed",
    speed_performance: "Performance",
    speed_mobile: "Mobile",
    speed_desktop: "Desktop",
    speed_opportunities: "Optimization Opportunities",
    speed_diagnostics: "Diagnostics",
    speed_comparison: "Industry Comparison",
    speed_your_score: "Your Score",
    speed_avg: "Industry Avg",
    speed_top: "Top 10%",
    speed_percentile: "Percentile",
    // Potential Boost
    potential_title: "Growth Potential with TopRankPulse",
    potential_desc: "Your score can improve by up to",
    potential_projected: "Projected Score",
    potential_current: "Current Score",
    // Competitor Comparison
    competitor_title: "Competitor Comparison",
    competitor_subtitle: "See how you stack up against your competitors",
    competitor_add: "Add Competitor URL",
    competitor_compare: "Compare Now",
    competitor_your_site: "Your Site",
    competitor_wins: "Where You Win",
    competitor_loses: "Where You Need to Improve",
    competitor_action: "Action Plan",
    competitor_priority: "Priority",
    competitor_impact: "Expected Impact",
    competitor_ranking: "Your Ranking",
    competitor_email_required: "Enter your email to unlock competitor comparison",
    // Blog Generator
    blog_title: "AI Blog Generator",
    blog_subtitle: "10 ready-to-publish articles for your website",
    blog_generate: "Generate 10 Articles",
    blog_generating: "Generating articles...",
    blog_traffic: "Est. Traffic",
    blog_keyword: "Target Keyword",
    blog_copy: "Copy Article",
    blog_edit: "Edit",
    blog_strategy: "Content Strategy",
    blog_schedule: "Posting Schedule",
    blog_gaps: "Content Gaps",
    blog_topics: "Primary Topics",
    blog_total_traffic: "Estimated Monthly Traffic",
    blog_email_required: "Enter your email to unlock AI blog generation",
  },
  sk: {
    hero_title: "Zistite, či AI vyhľadávače",
    hero_title_highlight: "Citujú vašu stránku",
    hero_subtitle: "Jediný nástroj, ktorý sleduje vašu viditeľnosť v ChatGPT, Perplexity a Gemini. Kompletný SEO, GEO a AI audit za sekundy.",
    analyze_btn: "Analyzovať",
    placeholder: "Zadajte URL vašej webstránky...",
    discount_text: "75% ZĽAVA - Limitovaná ponuka",
    discount_ends: "Ponuka končí o",
    analyzing: "Analyzujem vašu stránku...",
    scanning_seo: "Skenujem SEO metriky",
    checking_ai: "Kontrolujem AI viditeľnosť",
    analyzing_geo: "Analyzujem GEO faktory",
    generating: "Generujem AI riešenia",
    results_title: "Výsledky analýzy",
    ai_visibility: "AI Visibility Skóre",
    seo_audit: "SEO Audit",
    geo_analysis: "GEO Analýza",
    performance: "Výkon",
    competitors: "Konkurencia",
    ai_solutions: "AI Odporúčania",
    pricing_title: "Vyberte si plán",
    pricing_subtitle: "Začnite zadarmo, upgradnite keď potrebujete viac",
    get_started: "Začať",
    features: "Funkcie",
    per_month: "/mesiac",
    original_price: "Pôvodná cena",
    chatgpt_ready: "ChatGPT Pripravený",
    perplexity_ready: "Perplexity Pripravený",
    gemini_ready: "Gemini Pripravený",
    voice_search: "Hlasové vyhľadávanie",
    zero_click: "Zero-Click Potenciál",
    detected_region: "Detekovaný región",
    local_keywords: "Lokálne kľúčové slová",
    local_schema: "Lokálna schéma",
    load_time: "Čas načítania",
    mobile_friendly: "Mobilná verzia",
    core_web_vitals: "Core Web Vitals",
    impact: "Dopad",
    effort: "Náročnosť",
    priority: "Priorita",
    actions: "Akcie",
    trusted_by: "Dôveruje nám 10 000+ firiem po celom svete",
    your_location: "Vaša poloha",
    what_makes_different: "Čo nás odlišuje",
    features_competitors_dont_have: "Funkcie, ktoré konkurencia nemá",
    ai_citation_tracking: "AI Citation Tracking",
    ai_citation_desc: "Sledujte, či ChatGPT, Perplexity a Gemini citujú vašu stránku vo svojich odpovediach. Žiadny iný nástroj to neponúka.",
    voice_search_ready: "Pripravené na hlasové vyhľadávanie",
    voice_search_desc: "Optimalizujte pre hlasových asistentov a konverzačné dotazy. Získajte dedikované skóre hlasového vyhľadávania.",
    zero_click_analytics: "Zero-Click Analytika",
    zero_click_desc: "Pochopte, ako často sa vaša stránka zobrazuje vo vyhľadávaní bez kliknutia. Optimalizujte pre featured snippety.",
    // A/B Test Report translations
    ab_test_report: "A/B Test Report",
    compare_results: "Porovnať výsledky",
    before: "Pred",
    after: "Po",
    change: "Zmena",
    days_between: "dní medzi analýzami",
    improvements: "Zlepšenia",
    regressions: "Zhoršenia",
    ai_insights: "AI Poznatky",
    seo_changes: "SEO Zmeny",
    geo_changes: "GEO Zmeny",
    performance_changes: "Zmeny výkonu",
    view_history: "Zobraziť históriu",
    compare_with_previous: "Porovnať s predchádzajúcou",
    no_previous_analysis: "Nenašla sa predchádzajúca analýza",
    improvement_rate: "Miera zlepšenia",
    // Email capture translations
    email_required: "Získajte bezplatnú analýzu",
    email_subtitle: "Zadajte váš email pre kompletný SEO/GEO audit report",
    email_placeholder: "vas@email.sk",
    email_submit: "Odoslať report",
    email_privacy: "Rešpektujeme vaše súkromie. Žiadny spam.",
    email_marketing_consent: "Chcem dostávať ponuky TopRankPulse emailom (max. 5 do konca roka, odhlásenie jedným klikom).",
    email_invalid: "Prosím zadajte platný email",
    // AI Chat translations
    chat_title: "AI Asistent",
    chat_subtitle: "Opýtajte sa ma čokoľvek o SEO a marketingu",
    chat_placeholder: "Napíšte vašu otázku...",
    chat_send: "Odoslať",
    chat_greeting: "Ahoj! Som TopRankPulse AI. Ako vám môžem pomôcť so SEO, GEO alebo marketingom?",
    chat_thinking: "Premýšľam...",
    // Keyword Research & Content Writer
    tools_title: "SEO Nástroje",
    keyword_research: "Výskum kľúčových slov",
    keyword_placeholder: "Zadajte kľúčové slovo...",
    keyword_search: "Hľadať",
    keyword_results: "Výsledky",
    search_volume: "Objem",
    difficulty: "Obťažnosť",
    trend: "Trend",
    intent: "Zámer",
    related_topics: "Súvisiace témy",
    questions_asked: "Otázky ľudí",
    long_tail_keywords: "Long-tail kľúčové slová",
    content_writer: "Generátor obsahu",
    content_type: "Typ obsahu",
    content_topic: "Téma",
    content_keywords: "Cieľové kľúčové slová",
    content_tone: "Tón",
    content_generate: "Generovať obsah",
    content_result: "Vygenerovaný obsah",
    seo_score: "SEO Skóre",
    copy_content: "Kopírovať",
    suggestions: "Odporúčania",
    // Templates
    templates_title: "Rýchle šablóny",
    templates_subtitle: "Kliknutím vyplníte formulár",
    tpl_ecommerce: "E-commerce",
    tpl_saas: "SaaS",
    tpl_local: "Lokálny biznis",
    tpl_blog: "Blog / Médiá",
    tpl_social: "Sociálne siete",
    // Admin Dashboard
    admin_title: "Admin Panel",
    admin_leads: "Leady",
    admin_chats: "Chat logy",
    admin_discounts: "Zľavové kódy",
    admin_total: "Celkom",
    admin_hot_leads: "Horúce leady",
    admin_avg_score: "Priem. skóre",
    admin_new: "Nové",
    admin_reviewed: "Skontrolované",
    admin_used: "Použité",
    admin_unused: "Nepoužité",
    admin_conversion: "Konverzný pomer",
    admin_email: "Email",
    admin_url: "URL",
    admin_score: "Skóre",
    admin_grade: "Hodnotenie",
    admin_date: "Dátum",
    admin_status: "Stav",
    admin_language: "Jazyk",
    admin_question: "Otázka",
    admin_answer: "Odpoveď",
    admin_code: "Kód",
    admin_type: "Typ",
    admin_discount: "Zľava",
    admin_expires: "Expirácia",
    admin_back: "Späť na stránku",
    admin_export: "Export",
    admin_filter_all: "Všetky",
    admin_no_data: "Zatiaľ žiadne dáta",
    admin_mark_reviewed: "Označiť ako skontrolované",
    // Landing page enhancements
    free_tools: "100% Bezplatné nástroje",
    free_tools_desc: "Žiadna kreditná karta. Okamžité výsledky.",
    analyses_done: "dokončených analýz",
    schedule_rescan: "Naplánovať opakovaný sken",
    rescan_frequency: "Frekvencia",
    rescan_daily: "Denne",
    rescan_weekly: "Týždenne",
    rescan_monthly: "Mesačne",
    rescan_scheduled: "Sken naplánovaný!",
    all_free_title: "Všetko zadarmo",
    all_free_items: "SEO Audit,AI Visibility Skóre,GEO Analýza,Výskum kľúčových slov,Generátor obsahu,AI Chat Asistent,A/B Test Reporty,Analýza konkurencie",
    // AI Models Section
    ai_models_title: "Sledujeme vašu viditeľnosť v",
    ai_models_subtitle: "Každom veľkom AI vyhľadávači",
    ai_models_desc: "Žiadna registrácia. Žiadny kód. Výsledky za sekundy.",
    ai_chatgpt: "ChatGPT",
    ai_perplexity: "Perplexity",
    ai_gemini: "Gemini",
    ai_copilot: "Copilot",
    ai_models_cta: "Zistite, či citujú váš web",
    // Backlink Checker
    backlink_checker: "Kontrola spätných odkazov",
    backlink_url_placeholder: "Zadajte URL na kontrolu backlinkov...",
    backlink_check: "Skontrolovať",
    backlink_total: "Celkom backlinkov",
    backlink_dofollow: "Dofollow",
    backlink_nofollow: "Nofollow",
    backlink_da: "Priem. autorita domén",
    backlink_score: "Backlink skóre",
    backlink_domains: "Odkazujúce domény",
    backlink_top: "Top spätné odkazy",
    backlink_anchors: "Anchor texty",
    backlink_source: "Zdroj",
    backlink_anchor: "Anchor",
    backlink_type: "Typ",
    backlink_page: "Typ stránky",
    // Before vs After
    comparison_title: "Rozdiel je jasný",
    comparison_without: "Bez TopRankPulse",
    comparison_with: "S TopRankPulse",
    comparison_clicks: "klikov/mesiac",
    comparison_not_visible: "Neviditeľný pre AI",
    comparison_recommended: "Odporúčaný AI",
    // Site Speed
    site_speed: "Rýchlosť webu",
    speed_url_placeholder: "Zadajte URL na analýzu rýchlosti...",
    speed_check: "Analyzovať rýchlosť",
    speed_performance: "Výkon",
    speed_mobile: "Mobil",
    speed_desktop: "Desktop",
    speed_opportunities: "Možnosti optimalizácie",
    speed_diagnostics: "Diagnostika",
    speed_comparison: "Porovnanie s odvetvím",
    speed_your_score: "Vaše skóre",
    speed_avg: "Priemer odvetvia",
    speed_top: "Top 10%",
    speed_percentile: "Percentil",
    // Potential Boost
    potential_title: "Rastový potenciál s TopRankPulse",
    potential_desc: "Vaše skóre sa môže zlepšiť až o",
    potential_projected: "Predpokladané skóre",
    potential_current: "Aktuálne skóre",
    // Competitor Comparison
    competitor_title: "Porovnanie s konkurenciou",
    competitor_subtitle: "Zistite, ako ste na tom oproti konkurencii",
    competitor_add: "Pridať URL konkurencie",
    competitor_compare: "Porovnať teraz",
    competitor_your_site: "Váš web",
    competitor_wins: "Kde vyhrávate",
    competitor_loses: "Kde sa treba zlepšiť",
    competitor_action: "Akčný plán",
    competitor_priority: "Priorita",
    competitor_impact: "Očakávaný dopad",
    competitor_ranking: "Vaše poradie",
    competitor_email_required: "Zadajte email pre odomknutie porovnania",
    // Blog Generator
    blog_title: "AI Generátor blogov",
    blog_subtitle: "10 článkov pripravených na publikovanie",
    blog_generate: "Generovať 10 článkov",
    blog_generating: "Generujem články...",
    blog_traffic: "Odhadovaná návštevnosť",
    blog_keyword: "Cieľové kľúčové slovo",
    blog_copy: "Kopírovať článok",
    blog_edit: "Upraviť",
    blog_strategy: "Obsahová stratégia",
    blog_schedule: "Plán publikovania",
    blog_gaps: "Obsahové medzery",
    blog_topics: "Hlavné témy",
    blog_total_traffic: "Odhadovaná mesačná návštevnosť",
    blog_email_required: "Zadajte email pre odomknutie generátora blogov",
  },
  cs: {
    hero_title: "Zjistěte, zda AI vyhledávače",
    hero_title_highlight: "Citují vaši stránku",
    hero_subtitle: "Jediný nástroj, který sleduje vaši viditelnost v ChatGPT, Perplexity a Gemini. Kompletní SEO, GEO a AI audit za sekundy.",
    analyze_btn: "Analyzovat",
    placeholder: "Zadejte URL vaší webstránky...",
    discount_text: "75% SLEVA - Limitovaná nabídka",
    discount_ends: "Nabídka končí za",
    analyzing: "Analyzuji vaši stránku...",
    scanning_seo: "Skenuji SEO metriky",
    checking_ai: "Kontroluji AI viditelnost",
    analyzing_geo: "Analyzuji GEO faktory",
    generating: "Generuji AI řešení",
    results_title: "Výsledky analýzy",
    ai_visibility: "AI Visibility Skóre",
    seo_audit: "SEO Audit",
    geo_analysis: "GEO Analýza",
    performance: "Výkon",
    competitors: "Konkurence",
    ai_solutions: "AI Doporučení",
    pricing_title: "Vyberte si plán",
    pricing_subtitle: "Začněte zdarma, upgradujte když potřebujete více",
    get_started: "Začít",
    features: "Funkce",
    per_month: "/měsíc",
    original_price: "Původní cena",
    chatgpt_ready: "ChatGPT Připraven",
    perplexity_ready: "Perplexity Připraven",
    gemini_ready: "Gemini Připraven",
    voice_search: "Hlasové vyhledávání",
    zero_click: "Zero-Click Potenciál",
    detected_region: "Detekovaný region",
    local_keywords: "Lokální klíčová slova",
    local_schema: "Lokální schéma",
    load_time: "Čas načtení",
    mobile_friendly: "Mobilní verze",
    core_web_vitals: "Core Web Vitals",
    impact: "Dopad",
    effort: "Náročnost",
    priority: "Priorita",
    actions: "Akce",
    trusted_by: "Důvěřuje nám 10 000+ firem po celém světě",
    your_location: "Vaše poloha",
    what_makes_different: "Co nás odlišuje",
    features_competitors_dont_have: "Funkce, které konkurence nemá",
    ai_citation_tracking: "AI Citation Tracking",
    ai_citation_desc: "Sledujte, zda ChatGPT, Perplexity a Gemini citují vaši stránku ve svých odpovědích. Žádný jiný nástroj to nenabízí.",
    voice_search_ready: "Připraveno na hlasové vyhledávání",
    voice_search_desc: "Optimalizujte pro hlasové asistenty a konverzační dotazy. Získejte dedikované skóre hlasového vyhledávání.",
    zero_click_analytics: "Zero-Click Analytika",
    zero_click_desc: "Pochopte, jak často se vaše stránka zobrazuje ve vyhledávání bez kliknutí. Optimalizujte pro featured snippety.",
    // A/B Test Report translations
    ab_test_report: "A/B Test Report",
    compare_results: "Porovnat výsledky",
    before: "Před",
    after: "Po",
    change: "Změna",
    days_between: "dní mezi analýzami",
    improvements: "Zlepšení",
    regressions: "Zhoršení",
    ai_insights: "AI Poznatky",
    seo_changes: "SEO Změny",
    geo_changes: "GEO Změny",
    performance_changes: "Změny výkonu",
    view_history: "Zobrazit historii",
    compare_with_previous: "Porovnat s předchozí",
    no_previous_analysis: "Nenalezena předchozí analýza",
    improvement_rate: "Míra zlepšení",
    // Email capture translations
    email_required: "Získejte bezplatnou analýzu",
    email_subtitle: "Zadejte svůj email pro kompletní SEO/GEO audit report",
    email_placeholder: "vas@email.cz",
    email_submit: "Odeslat report",
    email_privacy: "Respektujeme vaše soukromí. Žádný spam.",
    email_marketing_consent: "Chci dostávat nabídky TopRankPulse e-mailem (max. 5 do konce roku, odhlášení jedním kliknutím).",
    email_invalid: "Prosím zadejte platný email",
    // Keyword Research & Content Writer
    tools_title: "SEO Nástroje",
    keyword_research: "Výzkum klíčových slov",
    keyword_placeholder: "Zadejte klíčové slovo...",
    keyword_search: "Hledat",
    keyword_results: "Výsledky",
    search_volume: "Objem",
    difficulty: "Obtížnost",
    trend: "Trend",
    intent: "Záměr",
    related_topics: "Související témata",
    questions_asked: "Otázky lidí",
    long_tail_keywords: "Long-tail klíčová slova",
    content_writer: "Generátor obsahu",
    content_type: "Typ obsahu",
    content_topic: "Téma",
    content_keywords: "Cílová klíčová slova",
    content_tone: "Tón",
    content_generate: "Generovat obsah",
    content_result: "Vygenerovaný obsah",
    seo_score: "SEO Skóre",
    copy_content: "Kopírovat",
    suggestions: "Doporučení",
    // Templates
    templates_title: "Rychlé šablony",
    templates_subtitle: "Kliknutím vyplníte formulář",
    tpl_ecommerce: "E-commerce",
    tpl_saas: "SaaS",
    tpl_local: "Lokální podnikání",
    tpl_blog: "Blog / Média",
    tpl_social: "Sociální sítě",
    // Admin Dashboard
    admin_title: "Admin Panel", admin_leads: "Kontakty", admin_chats: "Chat logy", admin_discounts: "Slevové kódy",
    admin_total: "Celkem", admin_hot_leads: "Horké kontakty", admin_avg_score: "Prům. skóre",
    admin_new: "Nové", admin_reviewed: "Zkontrolované", admin_used: "Použité", admin_unused: "Nepoužité",
    admin_conversion: "Konverzní poměr", admin_email: "Email", admin_url: "URL", admin_score: "Skóre",
    admin_grade: "Hodnocení", admin_date: "Datum", admin_status: "Stav", admin_language: "Jazyk",
    admin_question: "Otázka", admin_answer: "Odpověď", admin_code: "Kód", admin_type: "Typ",
    admin_discount: "Sleva", admin_expires: "Expirace", admin_back: "Zpět na stránku",
    admin_export: "Export", admin_filter_all: "Vše", admin_no_data: "Zatím žádná data",
    admin_mark_reviewed: "Označit jako zkontrolované",
    free_tools: "100% Zdarma", free_tools_desc: "Žádná kreditní karta. Okamžité výsledky.",
    analyses_done: "dokončených analýz", schedule_rescan: "Naplánovat opakovaný sken",
    rescan_frequency: "Frekvence", rescan_daily: "Denně", rescan_weekly: "Týdně", rescan_monthly: "Měsíčně",
    rescan_scheduled: "Sken naplánován!", all_free_title: "Vše zdarma",
    all_free_items: "SEO Audit,AI Visibility Skóre,GEO Analýza,Výzkum klíčových slov,Generátor obsahu,AI Chat,A/B Test Reporty,Analýza konkurence",
    ai_models_title: "Sledujeme vaši viditelnost v", ai_models_subtitle: "Každém velkém AI vyhledávači",
    ai_models_desc: "Žádná registrace. Žádný kód. Výsledky za sekundy.",
    ai_chatgpt: "ChatGPT", ai_perplexity: "Perplexity", ai_gemini: "Gemini", ai_copilot: "Copilot",
    ai_models_cta: "Zjistěte, zda citují váš web",
    backlink_checker: "Kontrola zpětných odkazů", backlink_url_placeholder: "Zadejte URL...", backlink_check: "Zkontrolovat",
    backlink_total: "Celkem", backlink_dofollow: "Dofollow", backlink_nofollow: "Nofollow",
    backlink_da: "Prům. autorita", backlink_score: "Backlink skóre", backlink_domains: "Odkazující domény",
    backlink_top: "Top zpětné odkazy", backlink_anchors: "Anchor texty",
    backlink_source: "Zdroj", backlink_anchor: "Anchor", backlink_type: "Typ", backlink_page: "Typ stránky",
    comparison_title: "Rozdíl je jasný", comparison_without: "Bez TopRankPulse", comparison_with: "S TopRankPulse",
    comparison_clicks: "kliků/měsíc", comparison_not_visible: "Neviditelný pro AI", comparison_recommended: "Doporučený AI",
    site_speed: "Rychlost webu", speed_url_placeholder: "Zadejte URL...", speed_check: "Analyzovat",
    speed_performance: "Výkon", speed_mobile: "Mobil", speed_desktop: "Desktop",
    speed_opportunities: "Možnosti optimalizace", speed_diagnostics: "Diagnostika",
    speed_comparison: "Srovnání s odvětvím", speed_your_score: "Vaše skóre",
    speed_avg: "Průměr odvětví", speed_top: "Top 10%", speed_percentile: "Percentil",
    potential_title: "Růstový potenciál s TopRankPulse", potential_desc: "Vaše skóre se může zlepšit až o",
    potential_projected: "Předpokládané skóre", potential_current: "Aktuální skóre",
    competitor_title: "Srovnání s konkurencí", competitor_subtitle: "Zjistěte, jak jste na tom",
    competitor_add: "Přidat URL konkurence", competitor_compare: "Porovnat",
    competitor_your_site: "Váš web", competitor_wins: "Kde vyhráváte", competitor_loses: "Kde je třeba zlepšit",
    competitor_action: "Akční plán", competitor_priority: "Priorita", competitor_impact: "Očekávaný dopad",
    competitor_ranking: "Vaše pořadí", competitor_email_required: "Zadejte email pro odemknutí",
    blog_title: "AI Generátor blogů", blog_subtitle: "10 článků připravených k publikaci",
    blog_generate: "Generovat 10 článků", blog_generating: "Generuji...",
    blog_traffic: "Odhadovaná návštěvnost", blog_keyword: "Cílové klíčové slovo",
    blog_copy: "Kopírovat", blog_edit: "Upravit", blog_strategy: "Obsahová strategie",
    blog_schedule: "Plán publikování", blog_gaps: "Obsahové mezery", blog_topics: "Hlavní témata",
    blog_total_traffic: "Odhadovaná měsíční návštěvnost", blog_email_required: "Zadejte email pro odemknutí",
  },
  de: {
    hero_title: "Prüfen Sie, ob KI-Suchmaschinen",
    hero_title_highlight: "Ihre Website zitieren",
    hero_subtitle: "Das einzige Tool, das Ihre Sichtbarkeit in ChatGPT, Perplexity & Gemini verfolgt. Komplettes SEO, GEO & KI-Audit in Sekunden.",
    analyze_btn: "Jetzt analysieren",
    placeholder: "Geben Sie Ihre Website-URL ein...",
    discount_text: "75% RABATT - Begrenzte Zeit",
    discount_ends: "Angebot endet in",
    analyzing: "Analysiere Ihre Website...",
    scanning_seo: "Scanne SEO-Metriken",
    checking_ai: "Prüfe KI-Sichtbarkeit",
    analyzing_geo: "Analysiere GEO-Faktoren",
    generating: "Generiere KI-Lösungen",
    results_title: "Ihre Analyseergebnisse",
    ai_visibility: "KI-Sichtbarkeit Score",
    seo_audit: "SEO-Audit",
    geo_analysis: "GEO-Analyse",
    performance: "Leistung",
    competitors: "Wettbewerber",
    ai_solutions: "KI-Lösungen",
    pricing_title: "Wählen Sie Ihren Plan",
    pricing_subtitle: "Starten Sie kostenlos, upgraden Sie wenn Sie mehr brauchen",
    get_started: "Loslegen",
    features: "Funktionen",
    per_month: "/Monat",
    original_price: "Originalpreis",
    chatgpt_ready: "ChatGPT bereit",
    perplexity_ready: "Perplexity bereit",
    gemini_ready: "Gemini bereit",
    voice_search: "Sprachsuche-Score",
    zero_click: "Zero-Click Potenzial",
    detected_region: "Erkannte Region",
    local_keywords: "Lokale Keywords",
    local_schema: "Lokales Schema",
    load_time: "Ladezeit",
    mobile_friendly: "Mobilfreundlich",
    core_web_vitals: "Core Web Vitals",
    impact: "Auswirkung",
    effort: "Aufwand",
    priority: "Priorität",
    actions: "Aktionen",
    trusted_by: "Vertraut von 10.000+ Unternehmen weltweit",
    your_location: "Ihr Standort",
    what_makes_different: "Was uns unterscheidet",
    features_competitors_dont_have: "Funktionen, die die Konkurrenz nicht hat",
    ai_citation_tracking: "KI-Zitat-Tracking",
    ai_citation_desc: "Verfolgen Sie, ob ChatGPT, Perplexity und Gemini Ihre Website in ihren Antworten zitieren. Kein anderes Tool bietet das.",
    voice_search_ready: "Sprachsuche-bereit",
    voice_search_desc: "Optimieren Sie für Sprachassistenten und konversationelle Anfragen. Erhalten Sie einen dedizierten Sprachsuche-Score.",
    zero_click_analytics: "Zero-Click Analytik",
    zero_click_desc: "Verstehen Sie, wie oft Ihre Website in Suchergebnissen erscheint ohne angeklickt zu werden. Optimieren Sie für Featured Snippets.",
    // Keyword Research & Content Writer
    tools_title: "SEO-Werkzeuge",
    keyword_research: "Keyword-Recherche",
    keyword_placeholder: "Suchbegriff eingeben...",
    keyword_search: "Suchen",
    keyword_results: "Ergebnisse",
    search_volume: "Volumen",
    difficulty: "Schwierigkeit",
    trend: "Trend",
    intent: "Absicht",
    related_topics: "Verwandte Themen",
    questions_asked: "Häufig gestellte Fragen",
    long_tail_keywords: "Long-Tail-Keywords",
    content_writer: "Inhaltsgenerator",
    content_type: "Inhaltstyp",
    content_topic: "Thema",
    content_keywords: "Ziel-Keywords",
    content_tone: "Tonfall",
    content_generate: "Inhalt generieren",
    content_result: "Generierter Inhalt",
    seo_score: "SEO-Score",
    copy_content: "Kopieren",
    suggestions: "Vorschläge",
    // Templates
    templates_title: "Schnellvorlagen",
    templates_subtitle: "Klicken Sie zum Ausfüllen",
    tpl_ecommerce: "E-Commerce",
    tpl_saas: "SaaS",
    tpl_local: "Lokales Geschäft",
    tpl_blog: "Blog / Medien",
    tpl_social: "Social Media",
    // Admin Dashboard
    admin_title: "Admin-Panel", admin_leads: "Leads", admin_chats: "Chat-Protokolle", admin_discounts: "Rabattcodes",
    admin_total: "Gesamt", admin_hot_leads: "Heiße Leads", admin_avg_score: "Durchschn. Score",
    admin_new: "Neu", admin_reviewed: "Überprüft", admin_used: "Verwendet", admin_unused: "Unbenutzt",
    admin_conversion: "Konversionsrate", admin_email: "E-Mail", admin_url: "URL", admin_score: "Punktzahl",
    admin_grade: "Bewertung", admin_date: "Datum", admin_status: "Status", admin_language: "Sprache",
    admin_question: "Frage", admin_answer: "Antwort", admin_code: "Code", admin_type: "Typ",
    admin_discount: "Rabatt", admin_expires: "Läuft ab", admin_back: "Zurück zur Seite",
    admin_export: "Exportieren", admin_filter_all: "Alle", admin_no_data: "Noch keine Daten",
    admin_mark_reviewed: "Als überprüft markieren",
    free_tools: "100% Kostenlos", free_tools_desc: "Keine Kreditkarte. Sofortige Ergebnisse.",
    analyses_done: "Analysen abgeschlossen", schedule_rescan: "Rescan planen",
    rescan_frequency: "Häufigkeit", rescan_daily: "Täglich", rescan_weekly: "Wöchentlich", rescan_monthly: "Monatlich",
    rescan_scheduled: "Rescan geplant!", all_free_title: "Alles inklusive kostenlos",
    all_free_items: "SEO-Audit,KI-Sichtbarkeit,GEO-Analyse,Keyword-Recherche,Inhaltsgenerator,KI-Chat,A/B-Test,Wettbewerberanalyse",
    ai_models_title: "Wir verfolgen Ihre Sichtbarkeit in", ai_models_subtitle: "Allen großen KI-Suchmaschinen",
    ai_models_desc: "Keine Registrierung. Kein Code. Sofortige Ergebnisse.",
    ai_chatgpt: "ChatGPT", ai_perplexity: "Perplexity", ai_gemini: "Gemini", ai_copilot: "Copilot",
    ai_models_cta: "Prüfen Sie, ob sie Ihre Website zitieren",
    backlink_checker: "Backlink-Prüfer", backlink_url_placeholder: "URL eingeben...", backlink_check: "Prüfen",
    backlink_total: "Gesamt", backlink_dofollow: "Dofollow", backlink_nofollow: "Nofollow",
    backlink_da: "Durchschn. Domain-Autorität", backlink_score: "Backlink-Score", backlink_domains: "Verweisende Domains",
    backlink_top: "Top-Backlinks", backlink_anchors: "Ankertexte",
    backlink_source: "Quelle", backlink_anchor: "Anker", backlink_type: "Typ", backlink_page: "Seitentyp",
    comparison_title: "Der Unterschied ist klar", comparison_without: "Ohne TopRankPulse", comparison_with: "Mit TopRankPulse",
    comparison_clicks: "Klicks/Monat", comparison_not_visible: "Für KI unsichtbar", comparison_recommended: "Von KI empfohlen",
    site_speed: "Seitengeschwindigkeit", speed_url_placeholder: "URL eingeben...", speed_check: "Analysieren",
    speed_performance: "Leistung", speed_mobile: "Mobil", speed_desktop: "Desktop",
    speed_opportunities: "Optimierungsmöglichkeiten", speed_diagnostics: "Diagnostik",
    speed_comparison: "Branchenvergleich", speed_your_score: "Ihr Score",
    speed_avg: "Branchendurchschnitt", speed_top: "Top 10%", speed_percentile: "Perzentil",
    potential_title: "Wachstumspotenzial mit TopRankPulse", potential_desc: "Ihr Score kann sich verbessern um",
    potential_projected: "Prognostizierter Score", potential_current: "Aktueller Score",
    competitor_title: "Wettbewerbervergleich", competitor_subtitle: "Sehen Sie, wie Sie abschneiden",
    competitor_add: "Wettbewerber-URL hinzufügen", competitor_compare: "Vergleichen",
    competitor_your_site: "Ihre Seite", competitor_wins: "Ihre Stärken", competitor_loses: "Verbesserungsbedarf",
    competitor_action: "Aktionsplan", competitor_priority: "Priorität", competitor_impact: "Erwartete Wirkung",
    competitor_ranking: "Ihr Ranking", competitor_email_required: "E-Mail für Vergleich eingeben",
    blog_title: "KI-Blog-Generator", blog_subtitle: "10 veröffentlichungsfertige Artikel",
    blog_generate: "10 Artikel generieren", blog_generating: "Generiere...",
    blog_traffic: "Geschätzter Traffic", blog_keyword: "Ziel-Keyword",
    blog_copy: "Kopieren", blog_edit: "Bearbeiten", blog_strategy: "Content-Strategie",
    blog_schedule: "Veröffentlichungsplan", blog_gaps: "Content-Lücken", blog_topics: "Hauptthemen",
    blog_total_traffic: "Geschätzter monatlicher Traffic", blog_email_required: "E-Mail zum Freischalten eingeben",
  },
  pl: {
    hero_title: "Sprawdź, czy wyszukiwarki AI",
    hero_title_highlight: "Cytują Twoją stronę",
    hero_subtitle: "Jedyne narzędzie, które śledzi Twoją widoczność w ChatGPT, Perplexity i Gemini. Kompletny audyt SEO, GEO i AI w sekundach.",
    analyze_btn: "Analizuj teraz",
    placeholder: "Wpisz URL swojej strony...",
    discount_text: "75% ZNIŻKI - Ograniczona oferta",
    discount_ends: "Oferta kończy się za",
    analyzing: "Analizuję Twoją stronę...",
    scanning_seo: "Skanuję metryki SEO",
    checking_ai: "Sprawdzam widoczność AI",
    analyzing_geo: "Analizuję czynniki GEO",
    generating: "Generuję rozwiązania AI",
    results_title: "Wyniki analizy",
    ai_visibility: "Wynik widoczności AI",
    seo_audit: "Audyt SEO",
    geo_analysis: "Analiza GEO",
    performance: "Wydajność",
    competitors: "Konkurencja",
    ai_solutions: "Rozwiązania AI",
    pricing_title: "Wybierz swój plan",
    pricing_subtitle: "Zacznij za darmo, ulepsz gdy potrzebujesz więcej",
    get_started: "Rozpocznij",
    features: "Funkcje",
    per_month: "/miesiąc",
    original_price: "Cena oryginalna",
    chatgpt_ready: "Gotowy na ChatGPT",
    perplexity_ready: "Gotowy na Perplexity",
    gemini_ready: "Gotowy na Gemini",
    voice_search: "Wynik wyszukiwania głosowego",
    zero_click: "Potencjał Zero-Click",
    detected_region: "Wykryty region",
    local_keywords: "Lokalne słowa kluczowe",
    local_schema: "Lokalna schema",
    load_time: "Czas ładowania",
    mobile_friendly: "Przyjazny dla urządzeń mobilnych",
    core_web_vitals: "Core Web Vitals",
    impact: "Wpływ",
    effort: "Wysiłek",
    priority: "Priorytet",
    actions: "Działania",
    trusted_by: "Zaufało nam 10 000+ firm na całym świecie",
    your_location: "Twoja lokalizacja",
    what_makes_different: "Co nas wyróżnia",
    features_competitors_dont_have: "Funkcje, których konkurencja nie ma",
    ai_citation_tracking: "Śledzenie cytowań AI",
    ai_citation_desc: "Śledź, czy ChatGPT, Perplexity i Gemini cytują Twoją stronę w swoich odpowiedziach. Żadne inne narzędzie tego nie oferuje.",
    voice_search_ready: "Gotowe na wyszukiwanie głosowe",
    voice_search_desc: "Optymalizuj dla asystentów głosowych i zapytań konwersacyjnych. Uzyskaj dedykowany wynik wyszukiwania głosowego.",
    zero_click_analytics: "Analityka Zero-Click",
    zero_click_desc: "Zrozum, jak często Twoja strona pojawia się w wynikach wyszukiwania bez kliknięcia. Optymalizuj dla featured snippets.",
    // Keyword Research & Content Writer
    tools_title: "Narzędzia SEO",
    keyword_research: "Badanie słów kluczowych",
    keyword_placeholder: "Wpisz słowo kluczowe...",
    keyword_search: "Szukaj",
    keyword_results: "Wyniki",
    search_volume: "Wolumen",
    difficulty: "Trudność",
    trend: "Trend",
    intent: "Intencja",
    related_topics: "Powiązane tematy",
    questions_asked: "Pytania ludzi",
    long_tail_keywords: "Słowa kluczowe long-tail",
    content_writer: "Generator treści",
    content_type: "Typ treści",
    content_topic: "Temat",
    content_keywords: "Docelowe słowa kluczowe",
    content_tone: "Ton",
    content_generate: "Generuj treść",
    content_result: "Wygenerowana treść",
    seo_score: "Wynik SEO",
    copy_content: "Kopiuj",
    suggestions: "Sugestie",
    // Templates
    templates_title: "Szybkie szablony",
    templates_subtitle: "Kliknij, aby wypełnić formularz",
    tpl_ecommerce: "E-commerce",
    tpl_saas: "SaaS",
    tpl_local: "Lokalny biznes",
    tpl_blog: "Blog / Media",
    tpl_social: "Media społecznościowe",
    // Admin Dashboard
    admin_title: "Panel Admina", admin_leads: "Kontakty", admin_chats: "Logi czatu", admin_discounts: "Kody rabatowe",
    admin_total: "Łącznie", admin_hot_leads: "Gorące kontakty", admin_avg_score: "Śr. wynik",
    admin_new: "Nowe", admin_reviewed: "Sprawdzone", admin_used: "Użyte", admin_unused: "Nieużyte",
    admin_conversion: "Współczynnik konwersji", admin_email: "Email", admin_url: "URL", admin_score: "Wynik",
    admin_grade: "Ocena", admin_date: "Data", admin_status: "Status", admin_language: "Język",
    admin_question: "Pytanie", admin_answer: "Odpowiedź", admin_code: "Kod", admin_type: "Typ",
    admin_discount: "Rabat", admin_expires: "Wygasa", admin_back: "Powrót do strony",
    admin_export: "Eksport", admin_filter_all: "Wszystkie", admin_no_data: "Brak danych",
    admin_mark_reviewed: "Oznacz jako sprawdzone",
    free_tools: "100% Za darmo", free_tools_desc: "Bez karty kredytowej. Natychmiastowe wyniki.",
    analyses_done: "wykonanych analiz", schedule_rescan: "Zaplanuj ponowne skanowanie",
    rescan_frequency: "Częstotliwość", rescan_daily: "Dziennie", rescan_weekly: "Tygodniowo", rescan_monthly: "Miesięcznie",
    rescan_scheduled: "Skanowanie zaplanowane!", all_free_title: "Wszystko za darmo",
    all_free_items: "Audyt SEO,AI Visibility,Analiza GEO,Badanie słów kluczowych,Generator treści,AI Chat,Test A/B,Analiza konkurencji",
    ai_models_title: "Śledzimy Twoją widoczność w", ai_models_subtitle: "Każdej dużej wyszukiwarce AI",
    ai_models_desc: "Bez rejestracji. Bez kodu. Wyniki w sekundy.",
    ai_chatgpt: "ChatGPT", ai_perplexity: "Perplexity", ai_gemini: "Gemini", ai_copilot: "Copilot",
    ai_models_cta: "Sprawdź, czy cytują Twoją stronę",
    backlink_checker: "Sprawdzanie linków zwrotnych", backlink_url_placeholder: "Wpisz URL...", backlink_check: "Sprawdź",
    backlink_total: "Łącznie", backlink_dofollow: "Dofollow", backlink_nofollow: "Nofollow",
    backlink_da: "Śr. autorytet domeny", backlink_score: "Wynik backlinków", backlink_domains: "Domeny odsyłające",
    backlink_top: "Najlepsze linki zwrotne", backlink_anchors: "Teksty kotwic",
    backlink_source: "Źródło", backlink_anchor: "Kotwica", backlink_type: "Typ", backlink_page: "Typ strony",
    comparison_title: "Różnica jest oczywista", comparison_without: "Bez TopRankPulse", comparison_with: "Z TopRankPulse",
    comparison_clicks: "kliknięć/miesiąc", comparison_not_visible: "Niewidoczny dla AI", comparison_recommended: "Polecany przez AI",
    site_speed: "Szybkość strony", speed_url_placeholder: "Wpisz URL...", speed_check: "Analizuj",
    speed_performance: "Wydajność", speed_mobile: "Mobilny", speed_desktop: "Desktop",
    speed_opportunities: "Możliwości optymalizacji", speed_diagnostics: "Diagnostyka",
    speed_comparison: "Porównanie branżowe", speed_your_score: "Twój wynik",
    speed_avg: "Średnia branżowa", speed_top: "Top 10%", speed_percentile: "Percentyl",
    potential_title: "Potencjał wzrostu z TopRankPulse", potential_desc: "Twój wynik może się poprawić o",
    potential_projected: "Prognozowany wynik", potential_current: "Aktualny wynik",
    competitor_title: "Porównanie z konkurencją", competitor_subtitle: "Zobacz, jak wypadasz",
    competitor_add: "Dodaj URL konkurenta", competitor_compare: "Porównaj",
    competitor_your_site: "Twoja strona", competitor_wins: "Twoje mocne strony", competitor_loses: "Do poprawy",
    competitor_action: "Plan działania", competitor_priority: "Priorytet", competitor_impact: "Oczekiwany efekt",
    competitor_ranking: "Twoja pozycja", competitor_email_required: "Podaj email aby odblokować",
    blog_title: "AI Generator blogów", blog_subtitle: "10 artykułów gotowych do publikacji",
    blog_generate: "Generuj 10 artykułów", blog_generating: "Generuję...",
    blog_traffic: "Szacowany ruch", blog_keyword: "Słowo kluczowe",
    blog_copy: "Kopiuj", blog_edit: "Edytuj", blog_strategy: "Strategia treści",
    blog_schedule: "Plan publikacji", blog_gaps: "Luki w treści", blog_topics: "Główne tematy",
    blog_total_traffic: "Szacowany miesięczny ruch", blog_email_required: "Podaj email aby odblokować",
  },
  hu: {
    hero_title: "Ellenőrizze, hogy az AI keresők",
    hero_title_highlight: "Idézik-e a weboldalát",
    hero_subtitle: "Az egyetlen eszköz, amely követi láthatóságát a ChatGPT, Perplexity és Gemini rendszerekben. Teljes SEO, GEO és AI audit másodpercek alatt.",
    analyze_btn: "Elemzés most",
    placeholder: "Adja meg weboldala URL-jét...",
    discount_text: "75% KEDVEZMÉNY - Korlátozott idő",
    discount_ends: "Az ajánlat véget ér",
    analyzing: "Weboldal elemzése...",
    scanning_seo: "SEO metrikák szkennelése",
    checking_ai: "AI láthatóság ellenőrzése",
    analyzing_geo: "GEO tényezők elemzése",
    generating: "AI megoldások generálása",
    results_title: "Elemzési eredmények",
    ai_visibility: "AI láthatósági pontszám",
    seo_audit: "SEO Audit",
    geo_analysis: "GEO Elemzés",
    performance: "Teljesítmény",
    competitors: "Versenytársak",
    ai_solutions: "AI Megoldások",
    pricing_title: "Válassza ki a csomagját",
    pricing_subtitle: "Kezdje ingyen, frissítsen amikor többre van szüksége",
    get_started: "Kezdés",
    features: "Funkciók",
    per_month: "/hónap",
    original_price: "Eredeti ár",
    chatgpt_ready: "ChatGPT kész",
    perplexity_ready: "Perplexity kész",
    gemini_ready: "Gemini kész",
    voice_search: "Hangkeresési pontszám",
    zero_click: "Zero-Click potenciál",
    detected_region: "Észlelt régió",
    local_keywords: "Helyi kulcsszavak",
    local_schema: "Helyi séma",
    load_time: "Betöltési idő",
    mobile_friendly: "Mobilbarát",
    core_web_vitals: "Core Web Vitals",
    impact: "Hatás",
    effort: "Erőfeszítés",
    priority: "Prioritás",
    actions: "Műveletek",
    trusted_by: "Világszerte 10 000+ vállalkozás bízik bennünk",
    your_location: "Az Ön helye",
    what_makes_different: "Mi tesz minket különlegessé",
    features_competitors_dont_have: "Funkciók, amelyekkel a versenytársak nem rendelkeznek",
    ai_citation_tracking: "AI idézet követés",
    ai_citation_desc: "Kövesse nyomon, hogy a ChatGPT, Perplexity és Gemini idézi-e weboldalát válaszaiban. Egyetlen más eszköz sem kínálja ezt.",
    voice_search_ready: "Hangkeresésre kész",
    voice_search_desc: "Optimalizáljon hangasszisztensekre és beszélgetős lekérdezésekre. Kapjon dedikált hangkeresési pontszámot.",
    zero_click_analytics: "Zero-Click Analitika",
    zero_click_desc: "Értse meg, milyen gyakran jelenik meg weboldala a keresési eredmények között kattintás nélkül. Optimalizáljon kiemelt részletekre.",
    // Keyword Research & Content Writer
    tools_title: "SEO Eszközök",
    keyword_research: "Kulcsszókutatás",
    keyword_placeholder: "Adja meg a kulcsszót...",
    keyword_search: "Keresés",
    keyword_results: "Eredmények",
    search_volume: "Keresési mennyiség",
    difficulty: "Nehézség",
    trend: "Trend",
    intent: "Szándék",
    related_topics: "Kapcsolódó témák",
    questions_asked: "Gyakran feltett kérdések",
    long_tail_keywords: "Long-tail kulcsszavak",
    content_writer: "Tartalomgenerátor",
    content_type: "Tartalom típusa",
    content_topic: "Téma",
    content_keywords: "Cél kulcsszavak",
    content_tone: "Hangnem",
    content_generate: "Tartalom generálása",
    content_result: "Generált tartalom",
    seo_score: "SEO Pontszám",
    copy_content: "Másolás",
    suggestions: "Javaslatok",
    // Templates
    templates_title: "Gyors sablonok",
    templates_subtitle: "Kattintson az űrlap kitöltéséhez",
    tpl_ecommerce: "E-kereskedelem",
    tpl_saas: "SaaS",
    tpl_local: "Helyi vállalkozás",
    tpl_blog: "Blog / Média",
    tpl_social: "Közösségi média",
    // Admin Dashboard
    admin_title: "Admin Panel", admin_leads: "Érdeklődők", admin_chats: "Chat naplók", admin_discounts: "Kedvezménykódok",
    admin_total: "Összesen", admin_hot_leads: "Forró érdeklődők", admin_avg_score: "Átl. pontszám",
    admin_new: "Új", admin_reviewed: "Ellenőrzött", admin_used: "Felhasznált", admin_unused: "Felhasználatlan",
    admin_conversion: "Konverziós arány", admin_email: "Email", admin_url: "URL", admin_score: "Pontszám",
    admin_grade: "Értékelés", admin_date: "Dátum", admin_status: "Állapot", admin_language: "Nyelv",
    admin_question: "Kérdés", admin_answer: "Válasz", admin_code: "Kód", admin_type: "Típus",
    admin_discount: "Kedvezmény", admin_expires: "Lejárat", admin_back: "Vissza az oldalra",
    admin_export: "Exportálás", admin_filter_all: "Összes", admin_no_data: "Még nincsenek adatok",
    admin_mark_reviewed: "Megjelölés ellenőrzöttként",
    free_tools: "100% Ingyenes", free_tools_desc: "Nem kell bankkártya. Azonnali eredmények.",
    analyses_done: "elvégzett elemzés", schedule_rescan: "Újraszkennelés ütemezése",
    rescan_frequency: "Gyakoriság", rescan_daily: "Naponta", rescan_weekly: "Hetente", rescan_monthly: "Havonta",
    rescan_scheduled: "Szkennelés ütemezve!", all_free_title: "Minden ingyen",
    all_free_items: "SEO Audit,AI Láthatóság,GEO Elemzés,Kulcsszókutatás,Tartalomgenerátor,AI Chat,A/B Teszt,Versenytárs elemzés",
    ai_models_title: "Nyomon követjük a láthatóságát", ai_models_subtitle: "Minden nagy AI keresőben",
    ai_models_desc: "Nincs regisztráció. Nincs kód. Eredmények másodpercek alatt.",
    ai_chatgpt: "ChatGPT", ai_perplexity: "Perplexity", ai_gemini: "Gemini", ai_copilot: "Copilot",
    ai_models_cta: "Nézze meg, hivatkoznak-e az oldalára",
    backlink_checker: "Visszahivatkozás-ellenőrző", backlink_url_placeholder: "Adja meg az URL-t...", backlink_check: "Ellenőrzés",
    backlink_total: "Összesen", backlink_dofollow: "Dofollow", backlink_nofollow: "Nofollow",
    backlink_da: "Átl. domain tekintély", backlink_score: "Backlink pontszám", backlink_domains: "Hivatkozó domainek",
    backlink_top: "Legjobb visszahivatkozások", backlink_anchors: "Horgonyszövegek",
    backlink_source: "Forrás", backlink_anchor: "Horgony", backlink_type: "Típus", backlink_page: "Oldaltípus",
    comparison_title: "A különbség egyértelmű", comparison_without: "TopRankPulse nélkül", comparison_with: "TopRankPulse-szal",
    comparison_clicks: "kattintás/hónap", comparison_not_visible: "AI számára láthatatlan", comparison_recommended: "AI által ajánlott",
    site_speed: "Weboldal sebesség", speed_url_placeholder: "Adja meg az URL-t...", speed_check: "Elemzés",
    speed_performance: "Teljesítmény", speed_mobile: "Mobil", speed_desktop: "Asztali",
    speed_opportunities: "Optimalizálási lehetőségek", speed_diagnostics: "Diagnosztika",
    speed_comparison: "Iparági összehasonlítás", speed_your_score: "Az Ön pontszáma",
    speed_avg: "Iparági átlag", speed_top: "Top 10%", speed_percentile: "Percentilis",
    potential_title: "Növekedési potenciál a TopRankPulse-szal", potential_desc: "Pontszáma javulhat akár",
    potential_projected: "Előrejelzett pontszám", potential_current: "Jelenlegi pontszám",
    competitor_title: "Versenytárs-összehasonlítás", competitor_subtitle: "Nézze meg, hogyan áll",
    competitor_add: "Versenytárs URL hozzáadása", competitor_compare: "Összehasonlítás",
    competitor_your_site: "Az Ön oldala", competitor_wins: "Erősségei", competitor_loses: "Fejlesztendő területek",
    competitor_action: "Akcióterv", competitor_priority: "Prioritás", competitor_impact: "Várható hatás",
    competitor_ranking: "Az Ön helyezése", competitor_email_required: "Adja meg emailjét a feloldáshoz",
    blog_title: "AI Blog Generátor", blog_subtitle: "10 publikálásra kész cikk",
    blog_generate: "10 cikk generálása", blog_generating: "Generálás...",
    blog_traffic: "Becsült forgalom", blog_keyword: "Cél kulcsszó",
    blog_copy: "Másolás", blog_edit: "Szerkesztés", blog_strategy: "Tartalomstratégia",
    blog_schedule: "Publikálási terv", blog_gaps: "Tartalmi hiányosságok", blog_topics: "Fő témák",
    blog_total_traffic: "Becsült havi forgalom", blog_email_required: "Adja meg emailjét a feloldáshoz",
  },
};
